import React, { Component } from "react";
import { connect } from "react-redux";

import { postServerDataWithTypes } from "../../../action/common_action";
import { ANY_ERROR } from "../../../action/user_action_types";
import { CAMPAIGN_DATA_OF_USER } from "../../../action/salesUser_action_types";

import Header from "../common/AuthHeader";
import SalesUserSideMenu from "../../../menu/SalesUserSideMenu";
import { history } from "../../../history/history";
import Pagination from "../../common/Pagination";
import { axiosInstnace, getLocalData } from "../../../util/util";
import { endPoints } from "../../../config";
import moment from "moment";
import { ShowStations } from "../../campaign/ShowStations";

class CampaignListComp extends Component {
  constructor(props) {
    super(props);
    //set initial state
    this.state = {
      salesUserInfo: getLocalData("salesUserInfo"),
      page: 1,
      limit: 10,
      totalRecords: 0,
      campaignsData: [],
      silver: {},
      gold: {},
      targetAmountAcheieved: 0,
      totalCamp: 0,
      grade: 0,
      showstationlist: false,
      currentStations: []
    };
  }

  //Get Campaign Data
  componentDidMount = () => {
    let { page } = this.state;
    this.getCampignsData(page);
  };

  
  hideshowstations = (e) => {
    this.setState({showstationlist: !this.state.showstationlist});
  };
  //Fetching Campign Data from backend
  getCampignsData = async (page) => {
    let { salesUserInfo } = this.state;
    let data = {
      email: salesUserInfo.email,
      withIncentives: true
      //   page
    };
    let data1 = await axiosInstnace.post(endPoints.getcampaignsbasedondsa, data);
    let {
      result,
      grade,
      targetAmountAcheieved,
      silver,
      gold,
      totalCamp
    } = data1.data.data;
    this.setState({
      campaignsData: result,
      silver,
      gold,
      targetAmountAcheieved,
      totalCamp,
      grade,
    });
  };

  //Go to Route bassed on path
  goToRoute = (name, data, path) => {
    history.push(path, { [name]: data });
  };

  render() {
    let { campaignsData, totalRecords, page, limit } = this.state;
    let indexNum = (page - 1) * limit;
    return (
      <div className="main_wrapper">
        <SalesUserSideMenu {...this.props} />
        <div className="dashboard_right_wrapper">
          <div className="right_wrapper_inner">
          <Header
              silver={this.state.silver}
              gold={this.state.gold}
              targetAmountAcheieved={this.state.targetAmountAcheieved}
              totalCamp={this.state.totalCamp}
              grade={this.state.grade}
            />
            <div className="dash_content_wrapper">
              <div className="content_wrapper_inner">
                {campaignsData && campaignsData.length > 0 ? (
                  <div className={`camp_wrapper`}>
                    <div className="running_cap_head">
                      <h2 className="camp_head">Incentive Details</h2>
                    </div>
                    <div className="camp_listing_wrapper">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Campaign ID</th>
                            <th>Campaign Name</th>
                            <th>Customer Email</th>
                            <th>Campaign Payment Date</th>
                            <th>Station</th>
                            <th>
                              Price{" "}
                              <img
                                src="../../assets/images/rupee-indian.svg"
                                className="camp_rupee"
                              />
                            </th>
                            <th>Incentive (%)</th>
                            <th>
                              Incentive Amount
                              <img
                                src="../../assets/images/rupee-indian.svg"
                                className="camp_rupee"
                              />
                            </th>
                            <th>Invoice Number</th>
                            <th>Invoice Date</th>
                            <th>Payment Date</th>
                            <th>Transaction Reference</th>
                          </tr>
                        </thead>
                        <tbody>
                          {campaignsData.map((campaign, index) => {
                            indexNum++;
                            return (
                              <tr key={index}>
                                <td>{indexNum}</td>
                                <td>{campaign._id}</td>
                                <td>{campaign.name}</td>
                                <td>{campaign.userEmail}</td>
                                {campaign.bigFmAudio === "false" &&
                                  campaign.paymentdates &&
                                  campaign.paymentdates.payId && (
                                    <td>
                                      {moment(
                                        parseInt(campaign.paymentdates.payId)
                                      ).format("DD MMM YYYY")}
                                    </td>
                                  )}
                                {campaign.bigFmAudio === "true" &&
                                  campaign.paymentdates &&
                                  campaign.paymentdates.payId_1 && (
                                    <td>
                                      {moment(
                                        parseInt(campaign.paymentdates.payId_1)
                                      ).format("DD MMM YYYY")}
                                    </td>
                                  )}
                                {!campaign.paymentdates && (
                                  <td>
                                    {moment(campaign.createdAt).format(
                                      "DD MMM YYYY"
                                    )}
                                  </td>
                                )}
                                <td> {campaign.station.includes(",") ? (
                              <a
                                onClick={(e) => {
                                  this.setState({
                                    currentStations:campaign.station.split(","),
                                    showstationlist: true
                                  })
                                }}
                              >
                                Multiple ({campaign.station.split(",").length})
                              </a>
                            ) : (
                              campaign.station
                            )}</td>
                                <td>{campaign.amount - campaign.audioCost - campaign.couponDiscount}</td>
                                <td>{campaign.invoiceno && campaign.incentivecalculated && campaign.incentivecalculated.percent ? campaign.incentivecalculated.percent : campaign.incentive }</td>
                                <td>{campaign.invoiceno && campaign.incentivecalculated && campaign.incentivecalculated.amount ? campaign.incentivecalculated.amount : (campaign.incentiveAmount && campaign.incentiveAmount.toFixed(2))}</td>
                                <td>
                                  {campaign.invoiceno}
                                </td>
                                <td>
                                  {campaign.invoicedate &&
                                    moment(
                                      campaign.invoicedate
                                    ).format("DD MMM YYYY")}
                                </td>
                                <td>{campaign.paymentdate && moment(campaign.paymentdate).format("DD MMM YYYY")}</td>
                                <td>
                                  {campaign.utrno }
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      <div className="paginationTable">
                        {totalRecords >= 10 && (
                          <Pagination
                            getAllData={this.getCampignsData}
                            totalRecords={totalRecords}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className={`bookcampaign`}>
                    <div>
                      <img src="../../assets/images/radio.png" />
                    </div>
                    <div className="book_camp_para">
                      <p>It seems like you don't have any incentive's yet</p>
                    </div>
                    {/* <div className="book_camp_btn"><button onClick={() => {
                      window.location.href = '/package'
                    }}>BOOK CAMPAIGNS</button></div> */}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {this.state.showstationlist && (
                <ShowStations
                  stations={this.state.currentStations}
                  closeAction={this.hideshowstations}
                />
              )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    campaignsData: state.sales.get("campaignsDataOfUser"),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSalesUserCampaign: (url, data, type) =>
      dispatch(postServerDataWithTypes(url, data, type)),
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CampaignListComp);



// WEBPACK FOOTER //
// ./web/components/salesUser/campaign/incentivedetails.jsx